import React from 'react';
import VerificationForm from "./VerificationForm";
import SignUpForm from "./SignUpForm";

export interface SignUpProps {
  onSuccess:() => void
}

export const SignUp = (props: SignUpProps) => {
  const [step, setStep] = React.useState('signUp');
  const [username, setUsername] = React.useState('');

  const handleSignUpSuccess = (username:string) => {
    setUsername(username);
    setStep('verify');
  }

  const handleVerifySuccess = () => {
    props.onSuccess();
  }

  switch(step) {
    case 'verify':
      return <>
        <VerificationForm username={username} onSuccess={handleVerifySuccess} />
      </>;
    default:
      return <>
        <SignUpForm onSuccess={handleSignUpSuccess}/>
      </>
  }
}

export default SignUp;